import React from "react";
import PropTypes from "prop-types";
import { Table } from "react-bootstrap";
import styled, { css } from "styled-components";

const Container = styled.div`
  min-width: 100%;
  max-width: 100%;
  padding: 25px 32px 56px;
  margin-bottom: 33px;
  background: #ffffff;
  box-shadow: 0px 3px 25px rgba(168, 168, 168, 0.3);

  .table-responsive {
    max-height: 500px;

    .table {
      margin-bottom: 0;
    }
  }
`;
const Title = styled.h1`
  font-weight: bold;
  font-size: 18px;
  line-height: 47px;
  color: #7b848d;
  ${({ theme: { mobile } }) =>
    mobile &&
    css`
      font-size: 16px;
    `}
`;
const TableHeader = styled.thead`
  height: 42px;
`;
const TableHeaderRow = styled.tr`
  vertical-align: middle;
  border-top: 1px solid #ecedf1;
  border-bottom: 1px solid #ecedf1;
`;
const TableHeaderCell = styled.th`
  text-align: center;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 15px;
  color: #7b848d;
  white-space: nowrap;
  ${({ mwidth }) => (mwidth ? `max-width: ${mwidth}px !important` : "")}
`;
const TableHeaderCellSticky = styled(TableHeaderCell)`
  position: sticky;
  top: 0;
  left: 0;
  border-bottom: none !important;
  background-color: #ecedf1 !important;
`;
const TableHeaderCellLeft = styled(TableHeaderCell)`
  text-align: left;
`;
const TableBody = styled.tbody`
  border: none !important;
`;
const TableBodyRow = styled(TableHeaderRow)`
  border-top: none;
  height: 40px;
  background-color: ${({ index }) => (index % 2 === 0 ? "#FAFAFF;" : "#FFFFFF")};

  &:hover {
    background-color: #eaeaea;
  }
`;
const TableBodyCell = styled.td`
  text-align: center;
  font-style: normal;
  font-size: 12px;
  white-space: nowrap;
  color: ${({ color }) => color || "#394149"};
`;
const TableBodyCellSticky = styled(TableBodyCell)`
  position: sticky;
  top: 42px;
  left: 0;
  background-color: #ecedf1 !important;
`;
const TableBodyCellLeft = styled(TableBodyCell)`
  text-align: left;
`;
const EmptyMessage = styled.div`
  color: #7b848d;
  font-weight: bold;
  text-align: center;
`;

function TableRow({ index, ...props }) {
  return (
    <TableBodyRow index={index}>
      <TableBodyCellSticky index={index}>{index + 1}</TableBodyCellSticky>
      <TableBodyCellLeft>{props.trademarkNumber}</TableBodyCellLeft>
      <TableBodyCellLeft>{props.type}</TableBodyCellLeft>
      <TableBodyCellLeft>{props.fillingDate}</TableBodyCellLeft>
      <TableBodyCellLeft>{props.registrationDate}</TableBodyCellLeft>
      <TableBodyCellLeft>{props.niceClassification}</TableBodyCellLeft>
      <TableBodyCellLeft>{props.trademarkStatus}</TableBodyCellLeft>
      <TableBodyCellLeft>{props.basis}</TableBodyCellLeft>
      <TableBodyCellLeft>{props.reference}</TableBodyCellLeft>
      <TableBodyCellLeft>{props.ownerIdNumber}</TableBodyCellLeft>
      <TableBodyCellLeft>{props.ownerName}</TableBodyCellLeft>
      <TableBodyCellLeft>{props.representativeIdNumber}</TableBodyCellLeft>
      <TableBodyCellLeft>{props.representativeName}</TableBodyCellLeft>
    </TableBodyRow>
  );
}

TableRow.propTypes = {
  index: PropTypes.number,
  trademarkNumber: PropTypes.string,
  type: PropTypes.string,
  fillingDate: PropTypes.string,
  registrationDate: PropTypes.string,
  niceClassification: PropTypes.string,
  trademarkStatus: PropTypes.string,
  basis: PropTypes.string,
  reference: PropTypes.string,
  ownerIdNumber: PropTypes.string,
  ownerName: PropTypes.string,
  representativeIdNumber: PropTypes.string,
  representativeName: PropTypes.string,
};

function GlobalSearchResultsDesktop({ globalSearchResults }) {
  if (!globalSearchResults) return null;

  return (
    <Container>
      <Title>Global Search Results</Title>
      {globalSearchResults.length ? (
        <Table responsive>
          <TableHeader>
            <TableHeaderRow>
              <TableHeaderCellSticky>#</TableHeaderCellSticky>
              <TableHeaderCellLeft>NUMBER</TableHeaderCellLeft>
              <TableHeaderCellLeft>TYPE</TableHeaderCellLeft>
              <TableHeaderCellLeft>FILLING DATE</TableHeaderCellLeft>
              <TableHeaderCellLeft>REGISTRATION DATE</TableHeaderCellLeft>
              <TableHeaderCellLeft>NICE CLASSIFICATION</TableHeaderCellLeft>
              <TableHeaderCellLeft>STATUS</TableHeaderCellLeft>
              <TableHeaderCellLeft>BASIS</TableHeaderCellLeft>
              <TableHeaderCellLeft>REFERENCE</TableHeaderCellLeft>
              <TableHeaderCellLeft>OWNER ID</TableHeaderCellLeft>
              <TableHeaderCellLeft>OWNER NAME</TableHeaderCellLeft>
              <TableHeaderCellLeft>REPRESENTATIVE ID</TableHeaderCellLeft>
              <TableHeaderCellLeft>REPRESENTATIVE NAME</TableHeaderCellLeft>
            </TableHeaderRow>
          </TableHeader>
          <TableBody>
            {globalSearchResults.map((globalSearchInfo, idx) => (
              <TableRow key={idx} index={idx} {...globalSearchInfo} />
            ))}
          </TableBody>
        </Table>
      ) : (
        <EmptyMessage>No conflicting Global search results found</EmptyMessage>
      )}
    </Container>
  );
}

GlobalSearchResultsDesktop.propTypes = {
  globalSearchResults: PropTypes.arrayOf(PropTypes.object),
};

export default GlobalSearchResultsDesktop;
